import { render, staticRenderFns } from "./CustomsView.vue?vue&type=template&id=3d7d64c9&scoped=true"
import script from "./CustomsView.vue?vue&type=script&lang=js"
export * from "./CustomsView.vue?vue&type=script&lang=js"
import style0 from "./CustomsView.vue?vue&type=style&index=0&id=3d7d64c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7d64c9",
  null
  
)

export default component.exports